import { defineStore } from 'pinia'
import type { ValidationType } from '@/stores/type/validation.type'
import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'

const api = useApi<ValidationType>()

const baseUrl = API.VALIDATION.BASE

export const useValidationStore = defineStore('validation', () => {
	const baseStore = useBaseStore<ValidationType>({ service: baseUrl, api })
	const resetAll = () => {
		baseStore.reset()
	}

	return {
		...baseStore,
		resetAll
	}
})
